import { render, staticRenderFns } from "./AuthorityManagementV2.vue?vue&type=template&id=227d4f81&scoped=true&"
import script from "./AuthorityManagementV2.vue?vue&type=script&lang=ts&"
export * from "./AuthorityManagementV2.vue?vue&type=script&lang=ts&"
import style0 from "./AuthorityManagementV2.vue?vue&type=style&index=0&id=227d4f81&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "227d4f81",
  null
  
)

export default component.exports